import React from 'react';
import styled from 'styled-components';
import { useSetting } from '../../../shared/hooks/useApi/useSetting';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { usePayment } from '../../../shared/hooks/useApi/usePayment';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import UniversalIconBtn from '../../../shared/component/headless/button/UniversalIconBtn';
import { MobileHeader, Title } from '../../../shared/component/modal/SearchModalLayout';
import belowIcon from '../../../asset/icon/below.png';

const JoinWaitlistModalMobile: React.FC = () => {
  const { user } = useAuth();
  const { setting } = useSetting();
  const { standardModal, clearModal } = useModalStore();
  const { requestAccess } = usePayment();

  if (!setting || standardModal == null || !user) return null;

  const handleRequestAccess = async () => {
    await requestAccess();
  }


  return (
    <JoinWaitlistModalComp>
      <MobileHeader>
        <Title>{getModalMessage('ACCESS_BY_INVITATION_TITLE')}</Title>
        <UniversalIconBtn
          size="fit"
          border={false}
          isTransparent
          backgroundImg={belowIcon}
          onClick={() => clearModal(400)}
          aria-label="Close"
        />
      </MobileHeader>
      <JoinWaitlistComp>
        {getModalMessage('JOIN_WAITLIST_BODY')}
      </JoinWaitlistComp>
      <HeadlessBtn
        value={getBtnName('REQUEST_ACCESS')}
        handleClick={handleRequestAccess}
        StyledBtn={SubmitButton}
      />
    </JoinWaitlistModalComp>
  );
}

const JoinWaitlistModalComp = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const JoinWaitlistComp = styled.div`
  padding-top: clamp(15px, 3vw, 30px);
  padding-bottom: clamp(20px, 5vw, 50px);
  ${({ theme }) => theme.typography.Body_02_2};
  color: ${({ theme }) => theme.colors.color_Gray_03};
  line-height: 1.5;
  white-space: pre-line;
`;

const SubmitButton = styled(BlackFullWidthBtn)`
  margin: 20px 0px 15px 0px;
`;

export default JoinWaitlistModalMobile;
